import React, { useState ,useEffect} from "react"
import ReactApexChart from "react-apexcharts"
import { useTranslation } from 'react-i18next';
import { useSelector, useDispatch } from "react-redux";

const chartapex = ({pricesData,sizesData}) => {
  const [prices,setPrecies]=useState([])
  const [sizes,setSizes]=useState([])
  const { t } = useTranslation();
  const AuthData = useSelector(state => state.Auth);

useEffect(() => {
  setPrecies(pricesData)
}, [pricesData])

useEffect(() => {
  const sizeSorted=sizesData.map(size=>parseInt(size)).sort((a,b)=>a-b)
  setSizes(sizeSorted)
}, [sizesData]) 

  const series = [
    { name: t("High Price"), data:prices },
    // { name: "Low Price- 2021", data: [1400000, 1100000, 1600000, 1200000, 1700000, 1300000, 1200000] },
  ]
  const options = {
    chart: { zoom: { enabled: !1 }, toolbar: { show: !1 } },
    colors: ["#556ee6", "#34c38f"],
    dataLabels: { enabled: !0 },
    stroke: { width: [3, 3], curve: "straight" },
    // title: { text: t("top results"), align: "left" , },
    // subtitle: { text: t("advance subtitle"), align: AuthData.lang !=="ar"? "left":"left"  },
    grid: {
      row: { colors: ["transparent", "transparent"], opacity: 0.2 },
      borderColor: "#f1f1f1",
    },
    markers: { style: "inverted", size: 6 },
    xaxis: {
      // title: { text: "Size" }, 
      title: { text: t("Area By Meter") },
      categories:sizes,
    },
    yaxis: {
      title: { text: t("Cost") },
      // min: 50000, max: 100000000
    },
    legend: {
      position: "top",
      horizontalAlign: "right",
      floating: !0,
      offsetY: -25,
      offsetX: -5,
    },
    responsive: [
      {
        breakpoint: 600,
        options: { chart: { toolbar: { show: !1 } }, legend: { show: !1 } },
      },
    ],
  }

  return (
    <ReactApexChart
      options={options}
      series={series}
      type="line"
      height="380"
    // className="apexcharts-canvas apexchartscq310u9c apexcharts-theme-light"
    />
  )
}

export default chartapex
